<template>
    <div class="sharingOps">
        <DropdownMenu :buttonClass="['base', 'btnShareOps']" :buttonArrowSVG="true">
            <template v-slot:button>
                <i class="fas fa-share-alt"></i>
                Share
            </template>
            <template  #menu="{ closeMenu }">
                <ul style="margin: 0; padding: 0; list-style: none">
                    <li v-for="(i, idx) in listShares" :key="idx" @click="shareSelectedAndClose(i, idx, closeMenu)">
                            <label :for="'share'+i.id">
                                <input type="checkbox" :checked="(i.checked>0)" :id="'share'+i.id">
                                {{i.name}}
                            </label>
                            <!-- <i class="far fa-check-square" v-if="listShares[idx].checked>0"></i> -->
                            <!-- <i class="far fa-square" v-else></i> -->
                    </li>
                </ul>
            </template>
        </DropdownMenu>
    </div>
</template>
<script>
import DropdownMenu from '@/core/components/DropdownMenu.vue'
export default {
    components: {
        DropdownMenu
    },
    name: "sharingOps",
    props: {
        shareOption: {
            type: Array,
            default: () => ([]),
        },
        eventData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            shareSelected: [],
            listShares: [
                { id: 'email', name: 'Email', checked: 0},
                { id: 'sms', name: 'SMS', checked: 0},
                { id: 'link', name: 'Link', checked: 0},
                { id: 'qr', name: 'Code Qr', checked: 0},
            ],
            refreshOpt: 0,
        };
    },
    created(){
        if(this.shareOption && Array.isArray(this.shareOption)){
            console.log('isArray', this.shareOption)
            this.shareSelected = [...this.shareOption];
            // console.log(this.eventData.id, 'load shareSelected', this.shareOption);
            // set checked status
            this.listShares.forEach((share, index) => {
                const isExist = this.shareSelected.find(i => i.id === share.id);
                if(isExist===undefined){
                    // No existe → agregar
                    // console.log('No existe → agregar', share, isExist)
                    this.shareSelected.push(share);
                }else{
                    //acutalizar valores
                    this.listShares[index].checked = this.shareSelected[index].checked;
                }
            });
        }else {
            this.shareSelected = this.listShares;
        }
        // console.log(this.eventData.id, 'created shareSelected', this.shareSelected);
    },
    methods : {
        shareSelectedAndClose(newShare, idx, closeMenu) {
            const valid = this.listShares.find(i => i.id === newShare.id);
            if (valid) {
                if (newShare.checked===0) {
                    // add
                    newShare.checked = 1;
                } else {
                    // remove
                    newShare.checked = 0;
                }
                this.shareSelected[idx] = newShare;
                this.listShares[idx] = this.shareSelected[idx];
            }
            this.refreshOpt++;
            console.log('listShares checked', idx, this.listShares[idx].checked);
            // this.$emit('update-sharing', this.eventData.id, this.shareSelected);
            // if (typeof closeMenu === 'function') closeMenu();
            // else console.warn('No se pudo cerrar el dropdown', typeof closeMenu);
            let payload = JSON.stringify(this.shareSelected);
			// @ts-ignore
			window.master.post('bRem/setUpdateField', {
				org_id: this.org_id,
				user_id: this.user_id,
				event_id: this.eventData.id,
				field_input: 'event_share',
				field_value: payload,
			})
			.then((response) => {
				// t.is_loading = false;
				console.log('bRem loaded', response.data);
				// this.getbRem();
			}).catch((error) => {
				// t.is_loading = false;
				console.log(error);
			});
		},
    }
};
</script>
<style lang="scss">
.sharingOps
{
    button.base.btnShareOps {
        border: 1px solid rgba(0, 0, 0, 0.25);
        padding: 3px 5px;
        border-radius: 1px;
    }
    .dropdown_menu ul li {
        padding: 0px 0px;
        label {
            display: flex;
            align-items: center;
            gap: 5px;
            width: 100%;
            padding: 5px 10px;
            font-size: 12px;
            i {font-size: 14px;}
        }
    }
}
</style>